import React, { useContext, useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { DropdownStatusList, EmptyString, FormTypeEdit, InsertDateFormat, PageSize, PageSizeOptions, StatusCodeDelete } from "utils/Constant";
import TransactionReportFormModal from "./TransactionReportFormModal";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { addSpaceEvery4, money } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import FilterIcon from "assets/icon/FilterIcon";
import XIcon from "assets/icon/XIcon";
import EditIcon from "assets/icon/EditIcon";
import { LocationContext } from "components/layout/MainContainer";
import ChevronDownIcon from "assets/icon/ChevronDownIcon";
import ChevronUpIcon from "assets/icon/ChevronUpIcon";
import { useModal } from "context/ModalContext";
import { useCallApi } from "api/apiHooks";
import Pagination from "components/Input/PaginationButton";

export default function TransactionReport(){
    const { locationId } = useContext(LocationContext)
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchTransactionList, fetchDeleteTransaction, fetchTransactionReportEdc } = useCallApi()

    const [transactionList, setTransactionList] = useState([])
    const [dateFrom, setDateFrom] = useState(new Date())
    const [dateTo, setDateTo] = useState(new Date())
    const [customerName, setCustomerName] = useState(EmptyString)
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [edcId, setEdcId] = useState(EmptyString)
    const [edcOptions, setEdcOptions] = useState([])
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageSize, setPageSize] = useState(PageSizeOptions[0].value)
    const [isFilterOpen, setIsFilterOpen] = useState(false)
    const [isToggled, setIsToggled] = useState(false)
    const [isSummaryOpen, setIsSummaryOpen] = useState(false)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [transactionReportFormModal, setTransactionReportFormModal] = useState({ isOpen: false, transactionId: 0, formType: FormTypeEdit, data: {} })

    async function handlePageChange(newIndex) {
        try {
            showLoading()

            const res = await fetchTransactionList(
                moment(dateFrom).format(InsertDateFormat),
                moment(dateTo).format(InsertDateFormat), 
                customerName,
                cardNumber,
                edcId === EmptyString ? 0 : edcId,
                status,
                pageSize === EmptyString ? PageSizeOptions[0].value : pageSize,
                parseInt(newIndex),
                EmptyString,
                localStorage.getItem("LocationId")
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setTransactionList(res)
            setTotalPages(total);
            setPageIndex(newIndex);

            // Get EDC
            const res2 = await fetchTransactionReportEdc(
                moment(dateFrom).format(InsertDateFormat),
                moment(dateTo).format(InsertDateFormat),
                status
            )

            if (!res2) return

            let data2 = res2.data
            let tempArray2 = []

            tempArray2.push({label: "All", value: EmptyString})

            for (let i = 0; i < data2.length; i++){
                tempArray2.push({ label: data2[i].bankCode + " - " + data2[i].edcName, value: String(data2[i].edcId) })
            }

            setEdcOptions(tempArray2)
            setEdcId(edcId)
        } finally {
            hideLoading();
        }
    }

    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    const filterBtnClick = () => {
        setIsFilterOpen(!isFilterOpen)
    }

    const filterEnterKeyPress = (e) => {
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}

    // Button Event Click
    const searchBtnClick = () => {
        handlePageChange(0)
    }
    const editBtnClick = (id) => {
        setTransactionReportFormModal({ isOpen: true, transactionId: id, formType: FormTypeEdit })
    }
    const deleteBtnClick = async (transactionId, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            const res = await fetchDeleteTransaction(transactionId, status)

            if (!res) return

            showSuccess()
            handlePageChange(pageIndex)
        }
    }

    const transactionFormModalClose = () => {
        setTransactionReportFormModal({ isOpen: false, transactionId: 0 })
        handlePageChange(pageIndex)
    }

    useEffect(() => {
        handlePageChange(0)
    },[pageSize, isToggled, locationId])

    return(
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-xl sm:text-2xl">Transaction Report</span>
            </div>
            <hr />

            {/* Summary Mobile Size */}
            <div>
                <div className={`sm:hidden  px-3 bg-slate-100 flex justify-between items-center
                        ${isSummaryOpen ? 'border-t border-x rounded-t-xl pt-3 pb-1'  : 'py-3 border rounded-xl'}
                    `}
                    onClick={() => { setIsSummaryOpen(!isSummaryOpen) }}
                >
                    <div className="flex flex-col">
                        <span className="text-xs">Total Amount</span>
                        <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalAmount)))}</span>
                    </div>
                    <div className="flex gap-2">
                        <div className="bg-black text-white px-3 py-1 rounded-full flex items-center">
                            <span className="text-xs">{transactionList?.data?.totalData} trx</span>
                        </div>
                        <div>
                            {isSummaryOpen ? <ChevronUpIcon className="fill-black w-6 h-6" /> : <ChevronDownIcon className="fill-black w-6 h-6" />}
                        </div>
                    </div>
                </div>
                {isSummaryOpen && 
                    <div className={`${localStorage.getItem('IsAdmin') === '1' ? '' : 'hidden'}`}>
                        <div className="border-x py-1 px-3 bg-slate-100 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-xs">Total Netto</span>
                                <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalNetto)))}</span>
                            </div>
                        </div>
                        <div className="border-x border-b rounded-b-xl pt-1 pb-3 px-3 bg-slate-100 flex justify-between items-center">
                            <div className="flex flex-col">
                                <span className="text-xs">Profit</span>
                                <span className="font-semibold">{"IDR " + money(String(Math.floor(transactionList?.data?.totalProfit)))}</span>
                            </div>
                        </div>
                    </div>
                }
            </div>
            
            <div className="xl:hidden mt-2 flex justify-end">
                <button className="flex justify-center items-center gap-2 rounded-full border p-2 bg-black w-full" onClick={filterBtnClick}>
                    {isFilterOpen ? <XIcon className="fill-white w-6 h-6" /> : <FilterIcon className="fill-white w-6 h-6" />}
                    <span className="text-white text-sm">Filter</span>
                </button>
            </div>

            <div className={`${isFilterOpen ? 'flex' : 'hidden'} xl:flex flex-col xl:flex-row gap-5 justify-between mt-5 bg-white sm:bg-transparent sm:p-0`}>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full flex-wrap text-sm sm:text-base">
                    <div className="flex flex-col gap-2 w-42">
                        <span>Date From</span>
                        <DatePicker className="w-full h-10 bg-white" value={dateFrom} onChange={setDateFrom} />
                    </div>
                    <div className="flex flex-col gap-2 w-42">
                        <span>Date To</span>
                        <DatePicker className="w-full h-10 bg-white" value={dateTo} onChange={setDateTo} />
                    </div>
                    <div className="flex flex-col gap-2 w-42">
                        <span>Customer Name</span>
                        <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} onKeyDown={filterEnterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-72">
                        <span>EDC</span>
                        <Dropdown className="w-full" value={edcId} options={edcOptions} onChange={(e) => { setEdcId(e.value) }} placeholder={"All"} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-28">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 mt-5">
                    <div>
                        <span className="text-sm sm:text-base">Show </span>
                    </div>
                    <div className="w-20">
                        <Dropdown className='text-sm sm:text-base h-8' options={PageSizeOptions} value={pageSize} onChange={(e) => { setPageSize(e.value) }} />
                    </div>
                </div>
            </div>
            
            {/* Wide Screen */}
            <div className="mt-5 w-full hidden xl:block">                
                <table className="w-full border bg-white text-md font-light mt-4 text-base 2xl:text-base">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-12">No</th>
                            <th className="font-semibold text-left px-1">Date</th>
                            {/* <th className="font-semibold text-left px-2">Card Number</th> */}
                            <th className="font-semibold text-left px-1">Name</th>
                            <th className="font-semibold text-left px-1">Card</th>
                            <th className="font-semibold text-left px-1">MDR</th>
                            <th className="font-semibold text-left px-1">Charge</th>
                            <th className="font-semibold text-left px-1">Gesek</th>
                            <th className="font-semibold text-left px-1">Cash</th>
                            <th className={`font-semibold text-left px-1 ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"}`}>Profit</th>
                            <th className="font-semibold text-left px-1">EDC</th>
                            <th className="font-semibold text-left px-1">Time</th>
                            <th className="font-semibold text-left px-1">Update By</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    {transactionList?.data?.listData?.length > 0 ? 
                        <tbody className="border">
                            {transactionList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-14 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2 text-nowrap">
                                            <span>{ moment(data.transactionDate).format("DD MMM yyyy") }</span>
                                        </td>
                                        {/* <td className="px-2 text-nowrap">
                                            <span>{ addSpaceEvery4(data.cardNumber) }</span>
                                        </td> */}
                                        <td className="px-2">
                                            <span>{ (data.customerName.length > 16 ? data.customerName.slice(0, 16).toUpperCase() + "..." : data.customerName.toUpperCase()) }</span>
                                        </td>
                                        <td className="px-2 text-nowrap">
                                            <div className="flex flex-col">
                                                <span>{ addSpaceEvery4(data.cardNumber) }</span>
                                                <span>{ data.bankCode + " - " + data.vendorName }</span>
                                            </div>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.edcMdr }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.mdr }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ money(String(Math.floor(data.amount))) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ money(String(Math.floor(data.netto))) }</span>
                                        </td>
                                        <td className={`px-2 ${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"}`}>
                                            <span>{ money(String(Math.floor(data.profit))) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.edcBank + " - " + (data.edcName.length > 12 ? data.edcName.slice(0, 12).toUpperCase() + "..." : data.edcName.toUpperCase()) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.time }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.updateBy.toUpperCase() }</span>
                                        </td>
                                        <td className="py-2 px-2">
                                            <div className="flex gap-2">
                                                <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} 
                                                    onClick={() => editBtnClick(data.transactionId)}
                                                >
                                                    <EditIcon className="w-4 fill-white" />
                                                </button>
                                                <button className={`p-2 bg-black rounded-lg flex gap-2 ${ data.status === StatusCodeDelete ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.transactionId, data.status)}>
                                                    {data.status === StatusCodeDelete ? <RevisionIcon className="w-4 fill-white" /> : <TrashIcon className="w-4 fill-white" />}
                                                </button>
                                            </div>
                                            
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    :
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan={12}>
                                    <span>No Transaction Data</span>
                                </td>
                            </tr>
                        </tbody>
                    }
                   
                    <tfoot>
                        <tr className="h-10">
                            <td colSpan={7} className="text-right pr-2">{"Rp " + money(String(Math.floor(transactionList?.data?.totalAmount)))}</td>
                            <td className={`${localStorage.getItem("IsAdmin") === "1" ? "text-nowrap" : "hidden"} px-2`}>{"Rp " + money(String(Math.floor(transactionList?.data?.totalNetto)))}</td>
                            <td colSpan={2} className={`${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} px-2`}>
                                {"Rp " + money(String(Math.floor(transactionList?.data?.totalProfit)))}
                            </td>
                            <td></td>
                            <td colSpan={2}>
                                <div className={`${localStorage.getItem("IsAdmin") === "1" ? "" : "hidden"} bg-black mx-2 py-1 px-3 rounded`}>
                                    <span className="text-white">
                                        Margin : { (Math.trunc(transactionList?.data?.margin * 100) / 100).toFixed(2) } %
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                </table>

                
            </div>

            {/* Mobile Size */}
            <div className="block xl:hidden mt-4">
                {transactionList?.data?.listData?.length > 0 ? 
                    <div className="flex flex-col gap-3">
                        {transactionList?.data?.listData?.map((data, i) => {
                            return(
                                <div className="flex flex-col bg-white border-b pb-3">
                                    <div className="flex w-full justify-between">
                                        <div className="flex flex-col">
                                            <div className="flex flex-col">
                                                <label className="text-sm">{data.customerName}</label>
                                                <label className="text-sm">{addSpaceEvery4(data.cardNumber)}</label>
                                                <label className="text-sm font-semibold">{"Rp " + money(String(Math.floor(data.amount)))}</label>
                                                <label className="text-sm font-semibold">{"Rp " + money(String(Math.floor(data.netto)))}</label>
                                            </div>
                                        </div>
                                        <div className="flex flex-col text-right">
                                            <label className="text-sm">{moment(data.transactionDate).format("DD MMM yyyy")}</label>
                                            <label className="text-sm">{data.mdr}</label>
                                            <label className={`text-sm font-semibold ${localStorage.getItem('IsAdmin') === '1' ? '' : 'hidden'}`}>{"Rp " + money(String(Math.floor(data.profit)))}</label>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <label className="text-sm">{data.edcBank + " - " + data.edcName}</label>
                                        <button className={`bg-black rounded-full px-2 py-1 flex gap-2`} onClick={() => deleteBtnClick(data.transactionId, data.status)}>
                                            <span className="text-xs text-white">{data.status === StatusCodeDelete ? 'Undelete' : 'Delete'}</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                :
                    <div>
                        <span>No Transaction</span>
                    </div>
                }
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
            
            {transactionReportFormModal.isOpen && ( 
                <TransactionReportFormModal 
                    onClose={transactionFormModalClose} 
                    data={transactionReportFormModal?.data} 
                    transactionId={transactionReportFormModal?.transactionId} 
                    formType={transactionReportFormModal?.formType} 
                /> 
            )}
        </div>
    )
}